exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host /deep/.completer-input,\n:host /deep/.dp-picker-input {\n  width: 100% !important;\n  display: block;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n:host /deep/.completer-input:focus {\n  border-color: #3c8dbc !important;\n  box-shadow: none !important;\n}\n\n:host /deep/.completer-dropdown-holder {\n  width: 100% !important;\n}\n\n.float {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.float .radio {\n  margin-top: 0;\n  margin-bottom: 0;\n  margin-left: 5px;\n}\n.float label {\n  margin: 0;\n}\n\n.service-date::after {\n  clear: both;\n  content: \"\";\n  display: block;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/latest-activity-edit/latest-activity-edit.component.css
// module id = ../../../../../src/app/latest-activity-edit/latest-activity-edit.component.css
// module chunks = main